<template>
  <v-dialog scrollable v-model="config.status.active" max-width="800px">
    <v-card class="dialog">
      <v-card-title class="primary pa-0">
        <v-toolbar flat class="amber blue-grey--text text--darken-4">
          <v-toolbar-title class="headline">滞在先の大家</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12" class="px-3">
                <v-select required
                  v-model="form.owner"
                  label="大家を選択して下さい"
                  item-text="label"
                  item-value="value"
                  :items="getOwnerItems"
                  :rules="rules.owner"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed v-if="isAuthed" color="secondary white--text" @click.stop="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'authorStaysModalsOwner',
  components: {
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          importing: false
        },
        datepickers: {
          date: false
        }
      },
      form: {
        valid: true,
        id: '',
        cid: '',
        clientId: '',
        authed: false,
        date: '',
        owner: '',
        house: {
          name: '',
          in: '',
          out: ''
        }
      },
      store: {
      },
      rules: {
        owner: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item/meta', {
            id: this.form.id,
            cid: this.form.cid,
            type: 'stay.app',
            form: {
              content: this.form.date,
              option: {
                owner: this.form.owner,
                house: {
                  name: this.form.house.name,
                  in: this.form.house.in,
                  out: this.form.house.out
                }
              }
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', {
                id: this.form.cid,
                type: 'app',
                value: {
                  date: this.form.date,
                  owner: this.form.owner,
                  house: {
                    name: this.form.house.name,
                    in: this.form.house.in,
                    out: this.form.house.out
                  }
                }
              })
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (val) {
      const { id, cid, clientId, authed, date, owner, house } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        cid: cid,
        clientId: clientId,
        authed: authed,
        date: date,
        owner: owner,
        house: house
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isAuthed () {
      return this.form.authed
    },
    getOwnerItems () {
      return Object.keys(this.$mango.arrange.stay.owners).map(key => {
        return {
          value: key,
          label: this.$mango.arrange.stay.owners[key]
        }
      })
    }
  }
}
</script>
